module.exports = __webpack_public_path__ + "img/dat00.d9e82910.png";